import {} from "../../request/api";
const state = {
    alarmHeight: [Math.floor(-1000 * 3.2808399), Math.floor(3000 * 3.2808399)],
    transportNowList: [],
    airNowList: [],
    GeneralNowList: [],
    AlarmNowList: {},
    showPlan: false,
    showPlanInfo: [],
    measureFlag: false,
    showFunMeunBarFLag: false,
    showMapMeunBarFlag: false,
    Position: null,
    aircraftInfo: {},
    AircraftInfos: {},
    ourMap: {},
    openRanging: false,
    watchAir: {
        General: true,
        Transport: true,
        UAV: true,
        Terminal: true,
    },

    roles: []
};
const mutations = {
    changeAlarmHeight(state, numArr) {
        var arr = [];
        arr[0] = Math.floor(numArr[0] * 3.2808399);
        arr[1] = Math.floor(numArr[1] * 3.2808399);
        state.alarmHeight = [...arr];
    },
    changeMeasureFlag(state, bool) {
        state.measureFlag = bool;
    },
    changeTransportNowList(state, num) {
        state.transportNowList = num;
    },
    changeAirNowList(state, num) {
        state.airNowList = num;
    },
    changeGeneralNowList(state, num) {
        state.GeneralNowList = num;
    },
    changeAlarmNowList(state, obj) {
        state.AlarmNowList = obj;
    },
    changeAircraftInfosList(state, obj) {
        state.AircraftInfos = obj;
    },

    initPlanshow(state, bool) {
        state.showPlan = bool;
    },
    changeshowPlanInfo(state, list) {
        state.showPlanInfo = list;
    },

    changeshowFunMeunBarFLag(state, bool) {
        state.showFunMeunBarFLag = bool;
    },
    changeshowFunMeunBar(state, { aircraftInfo, ourMap }) {
        state.aircraftInfo = aircraftInfo;
        state.ourMap = ourMap;
    },
    changeshowMapMeunBarFlag(state, bool) {
        state.showMapMeunBarFlag = bool;
    },
    changeinitPosition(state, obj) {
        state.Position = obj;
    },
    changeWatchAir(state, WatchAir) {
        state.watchAir = {...WatchAir };
    },
    changeOpenRanging(state, bool) {
        state.openRanging = bool;
    },
    changeRoles(state, roles) {
        state.roles = roles;
    }
};
const actions = {};

const getters = {
    alarmHeight(state) {
        return state.alarmHeight;
    },
    transportNowList(state) {
        return state.transportNowList;
    },
    airNowList(state) {
        return state.airNowList;
    },
    GeneralNowList(state) {
        return state.GeneralNowList;
    },
    showPlan(state) {
        return state.showPlan;
    },
    showPlanInfo(state) {
        return state.showPlanInfo;
    },
    measureFlag(state) {
        return state.measureFlag;
    },
    showFunMeunBarFLag(state) {
        return state.showFunMeunBarFLag;
    },
    showMapMeunBarFlag(state) {
        return state.showMapMeunBarFlag;
    },
    Position(state) {
        return state.Position;
    },
    aircraftInfo(state) {
        return state.aircraftInfo;
    },
    AircraftInfos(state) {
        return state.AircraftInfos;
    },
    ourMap(state) {
        return state.ourMap;
    },
    openRanging(state) {
        return state.openRanging;
    },
    AlarmNowList(state) {
        return state.AlarmNowList;
    },
    watchAir(state) {
        return state.watchAir;
    },
    roles(state) {
        return state.roles;
    },
};


export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}